import * as PropTypes from 'prop-types';
import * as React from 'react';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import { trackInteraction, trackView, ARTICLE_TYPE } from '@reverbdotcom/commons/dist/tracker';
import RelatedArticlesView from './related_articles_view';

class RelatedArticles extends React.Component {
  componentDidMount() {
    this.fetchRelatedArticles();
  }

  onArticleClick(articleId) {
    trackInteraction({
      componentName: 'RelatedArticles',
      type: ARTICLE_TYPE,
      entityId: articleId,
    });
  }

  trackView(articles) {
    trackView({
      componentName: 'RelatedArticles',
      type: ARTICLE_TYPE,
      ids: articles.map(article => article.id),
    });
  }

  fetchRelatedArticles() {
    APIRequest.V3.get(`/api/articles/${this.props.articleId}/related`, { table: this.props.table })
      .then((response) => {
        const { articles } = response;
        this.trackView(articles);
        this.setState({ articles });
      });
  }

  render() {
    if (!(this.state && this.state.articles)) { return null; }

    return (
      <RelatedArticlesView
        articles={this.state.articles}
        onClick={articleId => this.onArticleClick(articleId)}
      />
    );
  }
}

RelatedArticles.propTypes = {
  articleId: PropTypes.number.isRequired,
  table: PropTypes.string,
};

export default RelatedArticles;



// WEBPACK FOOTER //
// ./javascripts/components/articles/related_articles.jsx